<script setup lang="ts">
import { Card, CardContent } from '../ui/card';
import AppVersion from './AppVersion.vue';
import { Button } from '@/components/ui/button';
import { SendIcon } from 'lucide-vue-next';
import { eventEmitter } from '@/lib/eventEmitter.ts';

const showUserMessageDialog = () => {
    eventEmitter.emit('setUserMessageDialogVisibility', { visible: true });
};
</script>

<template>
    <Card class="w-full whitespace-nowrap rounded-none">
        <CardContent
            class="flex h-full items-center justify-between px-2 py-0 text-gray-600 dark:text-gray-400"
        >
            <Button
                variant="secondary"
                @click="showUserMessageDialog"
                class="h-[24px] rounded-sm px-2.5 text-xs"
            >
                <SendIcon style="width: 14px; height: 14px" />Feedback / Support
            </Button>
            <div class="flex gap-2">
                <AppVersion />
            </div>
        </CardContent>
    </Card>
</template>
